import classNames from 'classnames';
import EmptyIcon from 'assets/images/noImage/background store 4.svg';
const NewAdCard = ({
  createdDate,
  image,
  title,
  price,
  state,
  city,
  degree,
  wrapperClassName,
}: INewAdCardProps) => {
  return (
    <>
      <div
        className={classNames(
          'flex bg-white rounded-lg h-30 mx-2 px-2 py-3 shadow-md w-72 mb-3 ',
          wrapperClassName,
        )}
      >
        <div className="relative">
          <span className=" absolute top-2 right-1 text-xs text-created-day bg-white py-1 px-2 rounded-3xl">
            {createdDate}
          </span>
          {image ? (
            <img
              className="object-cover  rounded-md flex-none w-[100px] h-full"
              src={image}
              width={110}
              height={103}
              alt={title}
            />
          ) : (
            <img
              className="object-cover  rounded-md flex-none w-[100px] h-full"
              src={EmptyIcon}
              width={110}
              height={103}
              alt={title}
            />
          )}
        </div>
        <div>
          <div className="flex flex-col justify-between p-2 h-full">
            <p className=" text-black overflow-hidden max-w-[156px] truncate text-sm font-extrabold text-start">
              {title}
            </p>
            <div>
              <p className="mb-2  text-sm text-gray-6  text-start">
                قیمت :{price.toLocaleString()} تومان
              </p>

              <div className="flex  justify-between ">
                <div className="flex py-1">
                  {state && (
                    <>
                      <span className="icon-location text-primary text-xs"></span>
                      <p className=" font-normal text-xs text-error-3">
                        {state && state}
                        {city && `, ${city}`}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewAdCard;
